const colors = {
  darkest: '#292f36ff',
  lightest: '#f7fff7ff',
  accent1: '#4ecdc4',
  accent2: '#ff6b6b',
  accent3: '#ffe66d',
  visited: '#fdbcdc',
  path: '#ffe66d',
  green: '#66a266'
}

export default colors